import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getPOQuery = async (id) => {
    if (id) {
        const response = await axios.get(`${apiurl?.getPO}?purchaseOrderId=${id}`);
        return response;
    }
    return null;
};

const getPO = (id) => {
    return useQuery(['getPO'],
        () => getPOQuery(id), { refetchOnWindowFocus: false });
};

export { getPO, getPOQuery };
